import { Dispatch } from 'redux';
import ActionType from '../actionTypes/changeGraphicColor';
import ApiEndpoints from '../ApiEndpoints';
import { handleRequest } from './helpers';
import { GraphicSvgSchema, GraphicSchema } from '../../schemas/graphic';
import * as actions from './index';
import SnackBarType from '../../objects/app/snackbar';

export const loadGraphicSvg =
    (
        customerId: number | null,
        guestId: number | null,
        idGraphic: number,
        errors: any = {}
    ) =>
    async (dispatch: Dispatch): Promise<{ errors: any } | null> => {
        const url = ApiEndpoints.LOAD_GRAPHIC_SVG(
            idGraphic,
            customerId,
            guestId
        );
        const actionTypes = ActionType.loadGraphicSvg;

        return handleRequest(
            url,
            dispatch,
            actionTypes,
            (data: any) => {
                return GraphicSvgSchema.parse(data);
            },
            'get',
            {},
            {},
            {},
            null,
            () => {},
            errors
        );
    };

export const loadGraphicSvgReset = () => (dispatch: Dispatch) => {
    dispatch({
        type: ActionType.loadGraphicSvg.reset,
    });
};

export const saveGraphicSvg =
    (
        customerId: number | null,
        guestId: number | null,
        idGraphic: number,
        idLang: number,
        idDesign: number,
        svg: string,
        t: any = {},
        overwrite: boolean,
        errors: any = {}
    ) =>
    async (dispatch: Dispatch): Promise<{ errors: any } | null> => {
        const url = ApiEndpoints.SAVE_GRAPHIC_SVG(
            idGraphic,
            overwrite,
            customerId,
            guestId,
            idLang,
            idDesign
        );
        const actionTypes = ActionType.saveGraphicSvg;

        return handleRequest(
            url,
            dispatch,
            actionTypes,
            (data: any) => {
                return GraphicSchema.parse(data);
            },
            'post',
            {},
            { svg },
            {},
            null,
            () => {
                dispatch(
                    actions.addSnackbar(
                        t.saveGraphicSuccess,
                        SnackBarType.SUCCESS,
                        false
                    )
                );
            },
            errors
        );
    };

export const saveGraphicSvgReset = () => (dispatch: Dispatch) => {
    dispatch({
        type: ActionType.saveGraphicSvg.reset,
    });
};
